import { ViewCustomAction } from '@msdk/common'
import { EntityModel, PagedList, readEntityModelByName, readUserData } from '@msdk/definitions'

export class DeleteSiToImperial extends ViewCustomAction {
  private muListImperial: PagedList | undefined

  async onClick(): Promise<void> {
    await this.apiClient.update('CMPS/api/mu/deletesitoimperialconversions', null)
    this.asyncCache.deleteEntry('MU_LIST_SI_TO_IMPERIAL')
    this.reload()
    this.asyncCache.invalidateFrameworkCache('MeasurementUnit')
  }

  async onInit(): Promise<void> {
    const entityMetadata = readEntityModelByName('MEASUREMENT_UNIT')
    this.muListImperial = await this.asyncCache.getOrCreate('MU_LIST_SI_TO_IMPERIAL', async () => {
      return await this.apiClient.entity.getView('CMPS', entityMetadata as EntityModel, 'MU_LIST_SI_TO_IMPERIAL')
    })
  }

  isDisabled(): boolean {
    return false
  }

  isVisible(): boolean {
    const isLoggedCustomerAdmin = !!readUserData().role?.some((role: any) => role == 'app.admin')
    return isLoggedCustomerAdmin && !!this.muListImperial && this.muListImperial.totalItems > 0
  }
}
